module.exports = __webpack_public_path__ + "img/cover.ffe8c4af.png";